var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { ProjetoFundiariosApi } from '../../apis/projetos-fundiarios-api';
import { Grid } from '@mui/material';
import { DefaultAutoComplete } from '../DefaultAutoComplete';
import { HandleError } from '../../modules/utils/HandleError';
import { OUTRO_OPT } from '../../util/CommonUtils';
export var CampoLote = function (_a) {
    //region Constants
    var _b, _c, _d, _e, _f, _g;
    var _h = _a.filterBy, filterBy = _h === void 0 ? 'quadraOrProjeto' : _h, _j = _a.fullWhenAlone, fullWhenAlone = _j === void 0 ? true : _j, _k = _a.mode, mode = _k === void 0 ? 'automatic' : _k, _l = _a.addOther, addOther = _l === void 0 ? false : _l, _m = _a.refChange, refChange = _m === void 0 ? null : _m, _o = _a.disabled, disabled = _o === void 0 ? false : _o, _p = _a.required, required = _p === void 0 ? true : _p, _q = _a.valueList, valueList = _q === void 0 ? [] : _q, onShowChange = _a.onShowChange, fieldError = _a.fieldError, onChange = _a.onChange, value = _a.value;
    var _r = useState(false), disabledState = _r[0], setDisabledState = _r[1];
    var _s = useState(addOther), addOtherOpt = _s[0], setAddOtherOpt = _s[1];
    var _t = useState([]), values = _t[0], setValues = _t[1];
    var _u = useState(), error = _u[0], setError = _u[1];
    //endregion
    //region Hooks
    var isAutomaticMode = useMemo(function () {
        return mode === 'automatic';
    }, [mode]);
    var selectLoteProm = useCallback(function () {
        var _a, _b, _c, _d, _e;
        if (isAutomaticMode) {
            var params = {};
            var refId = typeof refChange === 'object' ? refChange === null || refChange === void 0 ? void 0 : refChange.id : refChange;
            var projetoId = (_c = (_b = (_a = value === null || value === void 0 ? void 0 : value.projetoFundiario) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : refId) !== null && _c !== void 0 ? _c : undefined;
            var quadraId = (_e = (_d = value === null || value === void 0 ? void 0 : value.quadra) === null || _d === void 0 ? void 0 : _d.id) !== null && _e !== void 0 ? _e : undefined;
            if (filterBy === 'projeto') {
                if (projetoId)
                    params['projetoFundId'] = projetoId;
            }
            else if (quadraId) {
                params['quadraId'] = quadraId;
            }
            else if (projetoId) {
                params['projetoFundId'] = projetoId;
            }
            return ProjetoFundiariosApi.selectAllLotes(params);
        }
        return Promise.resolve([]);
    }, [isAutomaticMode, refChange, (_b = value === null || value === void 0 ? void 0 : value.quadra) === null || _b === void 0 ? void 0 : _b.id, (_c = value === null || value === void 0 ? void 0 : value.projetoFundiario) === null || _c === void 0 ? void 0 : _c.id, filterBy]);
    var show = useMemo(function () {
        var _a;
        return addOther && ((_a = value === null || value === void 0 ? void 0 : value.lote) === null || _a === void 0 ? void 0 : _a.denominacao) === (OUTRO_OPT === null || OUTRO_OPT === void 0 ? void 0 : OUTRO_OPT.denominacao);
    }, [addOther, (_d = value === null || value === void 0 ? void 0 : value.lote) === null || _d === void 0 ? void 0 : _d.denominacao]);
    var isOutroLote = useMemo(function () {
        var _a;
        return ((_a = value === null || value === void 0 ? void 0 : value.lote) === null || _a === void 0 ? void 0 : _a.denominacao) === (OUTRO_OPT === null || OUTRO_OPT === void 0 ? void 0 : OUTRO_OPT.denominacao);
    }, [(_e = value === null || value === void 0 ? void 0 : value.lote) === null || _e === void 0 ? void 0 : _e.denominacao]);
    var isOutraQuadra = useMemo(function () {
        var _a;
        return ((_a = value === null || value === void 0 ? void 0 : value.quadra) === null || _a === void 0 ? void 0 : _a.denominacao) === (OUTRO_OPT === null || OUTRO_OPT === void 0 ? void 0 : OUTRO_OPT.denominacao);
    }, [(_f = value === null || value === void 0 ? void 0 : value.quadra) === null || _f === void 0 ? void 0 : _f.denominacao]);
    var size = useMemo(function () {
        if (!isOutraQuadra && !isOutroLote) {
            return 6;
        }
        var _size = (fullWhenAlone ? 12 : 6);
        return isOutroLote ? 6 : _size;
    }, [isOutraQuadra, isOutroLote, fullWhenAlone]);
    useEffect(function () {
    }, [values]);
    useEffect(function () {
        var _a;
        if (((_a = value === null || value === void 0 ? void 0 : value.quadra) === null || _a === void 0 ? void 0 : _a.denominacao) === (OUTRO_OPT === null || OUTRO_OPT === void 0 ? void 0 : OUTRO_OPT.denominacao)) {
            setAddOtherOpt(true);
        }
        else {
            setAddOtherOpt(false);
        }
    }, [(_g = value === null || value === void 0 ? void 0 : value.quadra) === null || _g === void 0 ? void 0 : _g.denominacao]);
    useEffect(function () {
        setDisabledState(false);
    }, [value === null || value === void 0 ? void 0 : value.projetoFundiario, value === null || value === void 0 ? void 0 : value.quadra]);
    useEffect(function () {
        if (isAutomaticMode) {
            selectLoteProm().then(function (response) {
                var list = (addOther ? (__spreadArray([OUTRO_OPT], response, true)) : response);
                setValues(list);
            }).catch(function (error) {
                setError(error);
            });
        }
        else {
            setValues(valueList);
        }
    }, [selectLoteProm, addOther, addOtherOpt]);
    useEffect(function () {
        onShowChange === null || onShowChange === void 0 ? void 0 : onShowChange(show);
    }, [show]);
    var selectedLote = useMemo(function () {
        var _a;
        if (!(value === null || value === void 0 ? void 0 : value.lote))
            return null;
        var found = values === null || values === void 0 ? void 0 : values.find(function (l) { var _a; return (l === null || l === void 0 ? void 0 : l.id) === ((_a = value === null || value === void 0 ? void 0 : value.lote) === null || _a === void 0 ? void 0 : _a.id); });
        if (!found) {
            found = values.find(function (l) { var _a; return (l === null || l === void 0 ? void 0 : l.denominacao) === ((_a = value === null || value === void 0 ? void 0 : value.lote) === null || _a === void 0 ? void 0 : _a.denominacao); });
        }
        if (!found && ((_a = value.lote) === null || _a === void 0 ? void 0 : _a.denominacao) === OUTRO_OPT.denominacao) {
            return values.find(function (l) { return (l === null || l === void 0 ? void 0 : l.denominacao) === OUTRO_OPT.denominacao; });
        }
        return found || value.lote;
    }, [value === null || value === void 0 ? void 0 : value.lote, values]);
    //endregion
    //region Handles
    var handleChange = function (dadosImovel) {
        var selected = dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.lote;
        var isOutro = (selected === null || selected === void 0 ? void 0 : selected.denominacao) === OUTRO_OPT.denominacao;
        var normalized = values.find(function (l) { return l.id === (selected === null || selected === void 0 ? void 0 : selected.id); })
            || values.find(function (l) { return l.denominacao === (selected === null || selected === void 0 ? void 0 : selected.denominacao); })
            || selected;
        onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, dadosImovel), { lote: normalized, outroLote: isOutro ? dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.outroLote : undefined }));
    };
    //endregion
    return (_jsxs(_Fragment, { children: [_jsx(Grid, __assign({ item: true, xs: 12, xl: size, lg: size, md: size }, { children: _jsx(DefaultAutoComplete, { onChange: function (_lote) { return handleChange === null || handleChange === void 0 ? void 0 : handleChange(__assign(__assign({}, value), { lote: _lote })); }, noOptionsText: "Nenhum lote encontrado", disabled: disabled || disabledState, placeholder: "Selecione um lote", fieldName: 'denominacao', fieldError: fieldError, required: required, value: selectedLote, fieldsList: values, label: "Lote", name: "lote" }) })), _jsx(HandleError, { error: error, handleClose: function () { return setError(undefined); } })] }));
};
